import styled from '@emotion/styled';
import { AppBar, Box, Button, ListItemIcon, Menu, MenuItem, Theme as MuiTheme } from '@mui/material';
import { Link } from 'react-router-dom';

export const SecondHeader = styled(AppBar)(({ theme }: { theme: MuiTheme }) => ({
  height: 90,
  background: theme.palette.background.default, // Adapt to theme
  color: theme.palette.text.primary, // Adapt text color to theme
}));

export const MenuBox = styled(Box)(() => ({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const OutterResponsiveMenuBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexGrow: 1,
}));

export const InnerResponsiveMenuBox = styled(Box)(() => ({
  borderRadius: 5,
  display: 'flex',
  alignItems: 'center',
  height: 70,
  flexGrow: 1,
}));

export const MenuButton = styled(Button)(({ theme }: { theme: MuiTheme }) => ({
  fontSize: 18,
  display: 'block',
  fontWeight: 300,
  letterSpacing: 2,
  borderRadius: '8px' /* Rounded corners */,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: theme.palette.action.hover, // Use theme hover color
    transform: 'translateY(-2px)',
  },
}));

export const ResponsiveMenu = styled(Menu)`
  & .MuiPaper-root {
    background-color: #232323;
    text-transform: none;
    border: 1px solid #555555;
    backdrop-filter: blur(5px); /* Add blur effect */
    -webkit-backdrop-filter: blur(5px); /* Add blur effect for Safari */
  }
  margin-top: 25px;
`;

export const ResponsiveMenuItem = styled(MenuItem)(({ theme }: { theme: MuiTheme }) => ({
  fontSize: 16,
  fontWeight: 300,
  letterSpacing: 2,
}));

export const ResponsiveListItemIcon = styled(ListItemIcon)(() => ({
  color: '#CCCCCC',
  marginBottom: 3,
}));

export const StyledLink = styled(Link)(() => ({
  textDecoration: 'none',
  borderRadius: 5,
  '&:hover': {
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
}));
